import React from "react";

function CountryFlagName({ countryFlag, countryName }) {
  return (
    <>
      {countryFlag && (
        <div
          data-countryname={countryName}
          className="box-size-35 rounded-circle overflow-hidden pe-0"
        >
          <img
            data-countryname={countryName}
            src={countryFlag}
            alt={countryName}
            className="img-fluid"
          />
        </div>
      )}

      <p data-countryname={countryName} className="fs-16 ms-2 mb-0">
        {countryName}
      </p>
    </>
  );
}

export default CountryFlagName;
